export const ModalType = {
    EMPTY: '',
    MESSAGE: 'MESSAGE',
    FORM: 'FORM',
    ERROR: 'ERROR',
    LOGIN: 'LOGIN'
}

export interface FormElement<T> {
    label: string,
    type: T,
    required: boolean,
    value: string | number | BasicDtaObject | Date | object | Array<object>
}

export type BasicDtaObject = {
    id: number,
    name: string
}

export type SelectConfig = {
    divId: string,
    storeKey?: string, // store list to take the options from, defaults to the field name + 's'
    filter?: (option: object, formObject: object) => boolean, // formObject: the current form values
    label?: (option: object) => string, // option text, defaults to its name
    visible?: (formObject: object) => boolean // hides the field while false
}

export class ModalData {
    isActive: boolean;
    type: typeof ModalType.EMPTY;
    header: string | null;
    formObject: object | undefined;
    callBack: Function | undefined;
    nonSelectables?: string[];
    hidden?: string[];
    selectConfigs?: SelectConfig[];
    optionals?: string[];
    template?: object;

    constructor(
        isActive: boolean,
        type: typeof ModalType.EMPTY,
        header: string,
        formObject: object | undefined,
        callBack: Function | undefined,
        nonSelectables?: string[],
        hidden?: string[],
        selectConfigs?: SelectConfig[],
        optionals?: string[],
        template?: object
    ) {
        this.isActive = isActive;
        this.type = type;
        this.header = header;
        this.formObject = formObject;
        this.callBack = callBack;
        this.nonSelectables = nonSelectables;
        this.hidden = hidden;
        this.selectConfigs = selectConfigs;
        this.optionals = optionals;
        this.template = template;
    }

}